<div *ngIf="settings" [innerHTML]="getStyle()"></div>
<div *ngIf="settings" [innerHTML]="getStyleAgain()"></div>
<div *ngIf="settings" [innerHTML]="getLogoStyle()"></div>